import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    if (this.element.tomselect) {
      this.element.tomselect.destroy();
    }

    const searchBothFields = this.data.get("search-both") === "true";
    const searchFields = searchBothFields ? ['text', 'value'] : ['text'];

    const baseConfig = {
      create: this.data.get("create") === "true",
      sortField: {
        field: "text",
        direction: "asc"
      },
      placeholder: this.data.get("placeholder") || "Selecciona una opción...",
      maxItems: 1,
      plugins: this.data.get("required") === "true" ? [] : ['clear_button'],
      allowEmptyOption: true,
      shouldSelect: false,
      items: this.element.value ? [this.element.value] : [],
      searchField: searchFields,
      render: this.getRenderConfig(this.data.get("render-type") || 'default')
    };

    if (this.data.get("search") === "false") {
      baseConfig.controlInput = null;
    }

    const ajaxUse = this.data.get("ajax-use") === "true";
    const ajaxUrlBase = this.data.get("ajax-url-base");
    const ajaxMinLength = parseInt(this.data.get("ajax-min-length") || "2");

    if (ajaxUse && ajaxUrlBase) {
      Object.assign(baseConfig, {
        valueField: 'id',
        labelField: 'text',
        searchField: ['text'],
        loadThrottle: 300,
        preload: true,
        load: function(query, callback) {
          if (!query.length) return callback();

          fetch(`${ajaxUrlBase}?q=${encodeURIComponent(query)}`, {
            headers: {
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
          })
          .then(response => {
            return response.json();
          })
          .then(data => {
            callback(data);
          })
          .catch(() => {
            callback();
          });
        },
        shouldLoad: function(query) {
          return query.length >= ajaxMinLength;
        }
      });
    } else {
      baseConfig.onInitialize = function() {
        const value = this.getValue();
        if (!value) {
          this.clear(true);
        }
      };
    }

    if (this.element.disabled) {
      baseConfig.disabled = true;
    }

    this.element.tomselect = new TomSelect(this.element, baseConfig);
  }

  disconnect() {
    if (this.element.tomselect) {
      this.element.tomselect.destroy();
    }
  }

  getRenderConfig(type) {
    const renderConfigs = {
      default: {
        option: this.renderDefaultView,
        item: this.renderDefaultView
      },
      level_view: {
        option: this.renderLevelOption,
        item: this.renderDefaultView
      },
      asset_view: {
        option: this.renderAssetOption,
        item: this.renderDefaultView
      }
    };

    return renderConfigs[type] || renderConfigs.default;
  }

  renderDefaultView = (item, escape) => {
    return `
      <div>${escape(item.text)}</div>
    `;
  }

  renderLevelOption = (item, escape) => {
    return `
      <div class="flex flex-col py-2 px-3 hover:bg-gray-50">
        ${item.path ? `
          <div class="text-sm text-gray-600">
            ${escape(item.path)}
          </div>
        ` : ''}
        <div class="text-base text-gray-900 ${item.path ? 'mt-0.5' : ''}">
          ${escape(item.text)}
        </div>
      </div>
    `;
  }

  renderAssetOption = (item, escape) => {
    return `
      <div class="flex flex-col py-2 px-3 hover:bg-gray-50">
        <div class="text-base text-gray-900">
          ${escape(item.text)}
        </div>
        ${item.nemo ? `
          <div class="text-sm text-gray-600 mt-0.5">
            ${escape(item.nemo)}
          </div>
        ` : ''}
      </div>
    `;
  }
}